import React from "react";

import Dialog from "material-ui/Dialog";
import DialogTitle from "material-ui/Dialog/DialogTitle";
import DialogContent from "material-ui/Dialog/DialogContent";
import DialogActions from "material-ui/Dialog/DialogActions";
import withStyles from "material-ui/styles/withStyles";
import CallIcon from "@material-ui/icons/Call";

import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import Button from "components/CustomButtons/Button.jsx";

import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";

class CallFormReport extends React.Component{
    
    render(){
      const data = this.props["data"];
      const pin = data["pin"];
      const form = data["conf"];

      const uiOrder = form["ui:order"];
      const callerData = data["caller"];
      const receiverData = data["receiver"];
      const callerProps = form["properties"]["caller_props"]["properties"];
      const receiverProps = form["properties"]["receiver_props"]["properties"];

      let callerList = [];
      let receiverList = [];

      for (const key in uiOrder["caller_props"]["ui:order"]) {
        let uiKey = uiOrder["caller_props"]["ui:order"][key];
        let itm = null;

        if (uiKey["key"])
          uiKey = uiKey["key"];

        if (callerProps[uiKey]['enum']) {
          for (const cpKey in callerProps[uiKey]['enum']) {
            if (callerProps[uiKey]['enum'][cpKey] == callerData[uiKey]) {
              itm = (
                <ItemGrid>
                    <p><b>{`${callerProps[uiKey]['title']}:`}</b> {`${callerProps[uiKey]['enumNames'][cpKey] || "None"}`}</p>
                </ItemGrid>
              );
            }
          }
        }
        else {
          itm = (
            <ItemGrid>
                <p><b>{`${callerProps[uiKey]['title']}:`}</b> {`${callerData[uiKey] || "None"}`}</p>
            </ItemGrid>
          );
        }

        callerList.push(itm);
      }

      let speakerItm1 = (
        <ItemGrid>
          <p><b>{'Speaker ID'}</b> {this.props.data.caller_speakerid}</p>
        </ItemGrid>
      )

      let deviceItm1 = (
        <ItemGrid>
          <p><b>{'Device ID'}</b> {this.props.data.caller_deviceid}</p>
        </ItemGrid>
      )

      callerList.push(speakerItm1);
      callerList.push(deviceItm1);

      for (const key in uiOrder["receiver_props"]["ui:order"]) {
        let uiKey = uiOrder["receiver_props"]["ui:order"][key];
        let itm = null;

        if (uiKey["key"])
          uiKey = uiKey["key"];

        if (receiverProps[uiKey]['enum']) {
          for (const cpKey in receiverProps[uiKey]['enum']) {
            if (receiverProps[uiKey]['enum'][cpKey] == receiverData[uiKey]) {
              itm = (
                <ItemGrid>
                    <p><b>{`${receiverProps[uiKey]['title']}:`}</b> {`${receiverProps[uiKey]['enumNames'][cpKey] || "None"}`}</p>
                </ItemGrid>
              );
            }
          }
        }
        else {
          itm = (
            <ItemGrid>
                <p><b>{`${receiverProps[uiKey]['title']}:`}</b> {`${receiverData[uiKey] || "None"}`}</p>
            </ItemGrid>
          );
        }

        receiverList.push(itm);
      }

      let speakerItm2 = (
        <ItemGrid>
          <p><b>{'Speaker ID'}</b> {this.props.data.receiver_speakerid}</p>
        </ItemGrid>
      )

      let deviceItm2 = (
        <ItemGrid>
          <p><b>{'Device ID'}</b> {this.props.data.receiver_deviceid}</p>
        </ItemGrid>
      )

      receiverList.push(speakerItm2);
      receiverList.push(deviceItm2);

      const { classes } = this.props;

        return (
          <Dialog
            open={true}
            onClose={() => this.props.onCallReportClose()}
            scroll={'paper'}
            aria-labelledby="scroll-dialog-title"
            classes={{
              paper: classes.modal
            }}
            keepMounted
            aria-describedby="classic-modal-slide-description"
          >
          <DialogTitle id="scroll-dialog-title"
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader + " " + classes.center}>
              <h4>Review all details below</h4>
          </DialogTitle>
            <DialogContent 
              id="classic-modal-slide-description"
              className={classes.modalBody}>
                <GridContainer style={{display: "flex"}}>
                    <ItemGrid xs={12} sm={12}>
                      <h5>Pin</h5>
                      <p>{pin}</p>
                    </ItemGrid>

                    <ItemGrid xs={12} sm={6}>
                      <h5>Caller</h5>
                      {callerList}
                    </ItemGrid>
					{/* only display receiver info in true two-line conversational collectionTypes */}
                    {[1,].includes(data.collectionType) && (
                            <ItemGrid xs={12} sm={6}>
                                <h5>Receiver</h5>
                                {receiverList}
                            </ItemGrid>
                        )
                    }
                  </GridContainer>
            </DialogContent>
            <DialogActions className={
                            classes.modalFooter +
                            " " +
                            classes.modalFooterCenter
                          }>
                            
              <Button 
                onClick={() => this.props.onCallReportClose()} 
                simple 
                color="defaultNoBackground">
                Cancel
              </Button>
              <Button 
                onClick={() => this.props.onReportModalCall()} 
                color="primary" 
                round
                customClass={
                  classes.modalSmallFooterFirstButton +
                  " " +
                  classes.modalSmallFooterSecondButton
                }>
                <CallIcon/>  Proceed
              </Button>
            </DialogActions>
          </Dialog>
        );
    }
}

export default withStyles(notificationsStyle)(CallFormReport);



// WEBPACK FOOTER //
// ./src/views/callform/components/CallFormReport.js